import { MarketView } from "./market-view";
import { useMarket } from "./use-market";

export const Markets = () => {
  const logic = useMarket();

  return <MarketView {...logic} />;
};
